import SpecialOffersContainerMobile from '../../../../components/containers/SpecialOffersContainerMobile';
import preloadCustomProps from '../../../utils/preloads/preloadCarRentalProps';
import deepmerge from '../../../utils/deepmerge';

const cmpConfig = {
  name: 'special-offers-container--mobile',
  moduleId: 'em-cmp-lib-airmodules',
  staticAssetsHost: 'https://em-frontend-assets.airtrfx.com',
  version: 'NO_NEEDED',
  containerConfig: {
    settings: {
      instance: SpecialOffersContainerMobile
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
